/* global */

import { css } from '@emotion/core';
import { StackView } from 'localmed-core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '../../shared/components/DiComponents';
import { Global } from '../../types';
import { BackButton } from '../pages/SchedulingPage/components/styles';

const GLOBAL = global as Global;

interface Props {
  phone: string;
  done: () => void;
  topic?: 'cancel' | 'reschedule';
}

export default function SchedulingApptIsImminent({ phone, done, topic = 'cancel' }: Props) {
  const disallowChangeTimeframe = GLOBAL?.CLIENT_ENV?.APPT_DISALLOW_CHANGE_TIMEFRAME || 48;
  return (
    <StackView
      spacing="xl"
      mt="lg"
      css={css`
        text-align: center;
      `}
    >
      <Alert type="warning" p="md" my="md">
        <FormattedMessage
          id="scheduling.SchedulingApptIsImminent.appointmentImminent"
          defaultMessage="This appointment is within {disallowChangeTimeframe} hours. Please call {phone} to {topic} this appointment. "
          values={{
            disallowChangeTimeframe,
            phone,
            topic,
          }}
        />
      </Alert>

      <BackButton onClick={done} variant="subtle" size="xl">
        <FormattedMessage
          id="scheduling.SchedulingApptIsImminent.keepAppointmentButton"
          defaultMessage="Done"
        />
      </BackButton>
    </StackView>
  );
}
